import api from '@/helpers/api'
class Notification{

    async getNotifications(category){
        return await api.get('bulk_messages',{
        params:{
            category:category
        }}).then(
            response => {
                return response.data
            }
        )
    }

    async saveNotification(){
        return await api.post('notification').then(
            response => {
                return response.data
            }
        )
    }
    async studentNotification(formData){
        return await api.post('student_notification',formData)
        .then(
            response => {
                return response.data
            }
        )
    }
    async getstudentNotification(){
        return await api.get('student_notification').then(
            response => {
                return response.data
            }
        )
    }

    async lecturerNotification(formData){
        return await api.post('lecturer_notification',formData).then(
            response => {
                return response.data
            }
        )
    }
    async getlecturerNotification(){
        return await api.get('lecturer_notification').then(
            response => {
                return response.data
            }
        )
    }

    async bulkNotification(formData){
        return await api.post('bulk_notification',formData).then(
            response => {
                return response.data
            }
        )
    }
    async getbulkNotification(){
        return await api.get('bulk_notification').then(
            response => {
                return response.data
            }
        )
    }
}

export default new Notification;